import contentStyleText from '../../packages/content/view/businessContent/assets/content_style_text.png';
import contentStyleTextSelected from '../../packages/content/view/businessContent/assets/content_style_text_selected.png';
import contentStyleImage from '../../packages/content/view/businessContent/assets/content_style_image.png';
import contentStyleImageSelected from '../../packages/content/view/businessContent/assets/content_style_image_selected.png';
import contentStyleTextImage from '../../packages/content/view/businessContent/assets/content_style_textImage.png';
import contentStyleTextImageSelected from '../../packages/content/view/businessContent/assets/content_style_textImage_selected.png';
import contentStyleAudio from '../../packages/content/view/businessContent/assets/content_style_audio.png';
import contentStyleAudioSelected from '../../packages/content/view/businessContent/assets/content_style_audio_selected.png';
import ImageAudioPic from '../../packages/content/view/businessContent/assets/content_style_image_audio.png';
import ImageAudioSelectedPic from '../../packages/content/view/businessContent/assets/content_style_image_audio_selected.png';
import contentStyleTextAudio from '../../packages/content/view/businessContent/assets/content_style_text_audio.png';
import contentStyleTextAudioSelected from '../../packages/content/view/businessContent/assets/content_style_text_audio_selected.png';
import TextImageAudioPic from '../../packages/content/view/businessContent/assets/content_style_text_image_audio.png';
import TextImageAudioSelectedPic from '../../packages/content/view/businessContent/assets/content_style_text_image_audio_selected.png';
import contentStyleVideo from '../../packages/content/view/businessContent/assets/content_style_video.png';
import contentStyleVideoSelected from '../../packages/content/view/businessContent/assets/content_style_video_selected.png';
import contentStyleTextVideo from '../../packages/content/view/businessContent/assets/content_style_text_video.png';
import contentStyleTextVideoSelected from '../../packages/content/view/businessContent/assets/content_style_text_video_selected.png';
import TextDocumentPic from '../../packages/content/view/businessContent/assets/text_document.png';
import TextDocumentSelectedPic from '../../packages/content/view/businessContent/assets/text_document_selected.png';
import ImageVideoPic from '../../packages/content/view/businessContent/assets/image_video.png';
import ImageVideoSelectedPic from '../../packages/content/view/businessContent/assets/image_video_selected.png';
import ImageDocumentPic from '../../packages/content/view/businessContent/assets/image_document.png';
import ImageDocumentSelectedPic from '../../packages/content/view/businessContent/assets/image_document_selected.png';
import AudioVideoPic from '../../packages/content/view/businessContent/assets/audio_video.png';
import AudioVideoSelectedPic from '../../packages/content/view/businessContent/assets/audio_video_selected.png';
import AudioDocumentPic from '../../packages/content/view/businessContent/assets/audio_document.png';
import AudioDocumentSelectedPic from '../../packages/content/view/businessContent/assets/audio_document_selected.png';
import TextImageVideoPic from '../../packages/content/view/businessContent/assets/text_image_video.png';
import TextImageVideoSelectedPic from '../../packages/content/view/businessContent/assets/text_image_video_selected.png';
import TextImageDocumentPic from '../../packages/content/view/businessContent/assets/text_image_document.png';
import TextImageDocumentSelectedPic from '../../packages/content/view/businessContent/assets/text_image_document_selected.png';
import ImageAudioVideoPic from '../../packages/content/view/businessContent/assets/image_audio_video.png';
import ImageAudioVideoSelectedPic from '../../packages/content/view/businessContent/assets/image_audio_video_selected.png';
import TextImageAudioDocumentPic from '../../packages/content/view/businessContent/assets/text_image_audio_document.png';
import TextImageAudioDocumentSelectedPic from '../../packages/content/view/businessContent/assets/text_image_audio_document_selected.png';
import SubtitlePic from '../../packages/content/view/businessContent/assets/subtitle.png';
import SubtitleSelectedPic from '../../packages/content/view/businessContent/assets/subtitle_selected.png';

// 风格切换
export const STYLE_TEXT = 'TEXT'; // 文本
export const STYLE_IMAGE = 'IMAGE'; // 图像
export const STYLE_AUDIO = 'AUDIO'; // 音频
export const STYLE_VIDEO = 'VIDEO'; // 视频
export const STYLE_DOCUMENT = 'DOCUMENT'; // 文档
export const STYLE_TEXT_IMAGE = 'TEXT_IMAGE'; //  文本+图像
export const STYLE_TEXT_AUDIO = 'TEXT_AUDIO'; // 文本+音频
export const STYLE_TEXT_VIDEO = 'TEXT_VIDEO'; // 文本+视频
export const STYLE_IMAGE_AUDIO = 'IMAGE_AUDIO'; // 图像+音频
export const STYLE_TEXT_IMAGE_AUDIO = 'TEXT_IMAGE_AUDIO'; // 文本+图像+音频
export const STYLE_NONE = 'NONE'; // 空白

interface ContentStyleTypeProp {
  [key: string]: {
    title: string;
    name: string;
    defaultSrc: string;
    selectedSrc: string;
  };
}
export const CONTENT_LAYOUTS: ContentStyleTypeProp = {
  TEXT: {
    title: '文本',
    name: '文本',
    defaultSrc: contentStyleText,
    selectedSrc: contentStyleTextSelected,
  },
  IMAGE: {
    title: '图片',
    name: '图片',
    defaultSrc: contentStyleImage,
    selectedSrc: contentStyleImageSelected,
  },
  AUDIO: {
    title: '音频',
    name: '音频',
    defaultSrc: contentStyleAudio,
    selectedSrc: contentStyleAudioSelected,
  },
  VIDEO: {
    title: '视频',
    name: '视频',
    defaultSrc: contentStyleVideo,
    selectedSrc: contentStyleVideoSelected,
  },
  DOCUMENT: {
    title: '文档',
    name: '文档',
    defaultSrc: SubtitlePic,
    selectedSrc: SubtitleSelectedPic,
  },
  TEXT_IMAGE: {
    title: '文本+图片',
    name: '图文',
    defaultSrc: contentStyleTextImage,
    selectedSrc: contentStyleTextImageSelected,
  },
  TEXT_AUDIO: {
    title: '文本+音频',
    name: '音文',
    defaultSrc: contentStyleTextAudio,
    selectedSrc: contentStyleTextAudioSelected,
  },
  TEXT_VIDEO: {
    title: '文本+视频',
    name: '视文',
    defaultSrc: contentStyleTextVideo,
    selectedSrc: contentStyleTextVideoSelected,
  },
  TEXT_DOCUMENT: {
    title: '文本+文档',
    name: '文本文档',
    defaultSrc: TextDocumentPic,
    selectedSrc: TextDocumentSelectedPic,
  },
  IMAGE_AUDIO: {
    title: '图片+音频',
    name: '音图',
    defaultSrc: ImageAudioPic,
    selectedSrc: ImageAudioSelectedPic,
  },
  IMAGE_VIDEO: {
    title: '图片+视频',
    name: '图片+视频',
    defaultSrc: ImageVideoPic,
    selectedSrc: ImageVideoSelectedPic,
  },
  IMAGE_DOCUMENT: {
    title: '图片+文档',
    name: '图片文档',
    defaultSrc: ImageDocumentPic,
    selectedSrc: ImageDocumentSelectedPic,
  },
  AUDIO_VIDEO: {
    title: '音频+视频',
    name: '音视',
    defaultSrc: AudioVideoPic,
    selectedSrc: AudioVideoSelectedPic,
  },
  AUDIO_DOCUMENT: {
    title: '音频+文档',
    name: '音频文档',
    defaultSrc: AudioDocumentPic,
    selectedSrc: AudioDocumentSelectedPic,
  },
  TEXT_IMAGE_AUDIO: {
    title: '文本+图片+音频',
    name: '文图音',
    defaultSrc: TextImageAudioPic,
    selectedSrc: TextImageAudioSelectedPic,
  },
  TEXT_IMAGE_VIDEO: {
    title: '文本+图片+视频',
    name: '视图文',
    defaultSrc: TextImageVideoPic,
    selectedSrc: TextImageVideoSelectedPic,
  },
  TEXT_IMAGE_DOCUMENT: {
    title: '文本+图片+文档',
    name: '文图文档',
    defaultSrc: TextImageDocumentPic,
    selectedSrc: TextImageDocumentSelectedPic,
  },
  IMAGE_AUDIO_VIDEO: {
    title: '图片+音频+视频',
    name: '音图视',
    defaultSrc: ImageAudioVideoPic,
    selectedSrc: ImageAudioVideoSelectedPic,
  },
  TEXT_IMAGE_AUDIO_VIDEO: {
    title: '文本+图片+音频+视频',
    name: '文本+图片+音频+视频',
    defaultSrc: TextImageAudioDocumentPic,
    selectedSrc: TextImageAudioDocumentSelectedPic,
  },
  TEXT_IMAGE_AUDIO_DOCUMENT: {
    title: '文本+图片+音频+文档',
    name: '文本+图片+音频+文档',
    defaultSrc: TextImageAudioDocumentPic,
    selectedSrc: TextImageAudioDocumentSelectedPic,
  },
};
